import axios from 'axios';

const API_URL = `${process.env.REACT_APP_API_URL}/api/categories/getall`;

// GET: /api/ProductTypes
export const getProductTypesApi = () => {
  return axios.get(API_URL);
};

// GET: /api/ProductTypes/{id}
export const getProductTypeApi = (id) => {
  
  return axios.get(`${process.env.REACT_APP_API_URL}/api/categories/getid/${id}`);
};

// POST: /api/ProductTypes
export const createProductTypeApi = (productType) => {
  const token = localStorage.getItem('accessToken');
  const config = {
    headers: {
      Authorization: `Bearer ${token}`
    },
  }
  return axios.post(`${process.env.REACT_APP_API_URL}/api/categories/create`, productType,config)
    .then(response => {
     
      return response.data; 
    })
    .catch(error => {

      throw error; 
    });
};

// PUT: /api/ProductTypes/{id}
export const updateProductTypeApi = (id, productType) => {
  const token = localStorage.getItem('accessToken');
  const config = {
    headers: {
      Authorization: `Bearer ${token}`
    },
  }
  return axios.put(`${process.env.REACT_APP_API_URL}/api/categories/updateCategoryById/${id}`, productType,config);
};

// DELETE: /api/ProductTypes/{id}
export const deleteProductTypeApi = (id) => {
  const token = localStorage.getItem('accessToken');
  const config = {
    headers: {
      Authorization: `Bearer ${token}`
    },
  }
  return axios.delete(`${process.env.REACT_APP_API_URL}/api/categories/deleteCategoryById/${id}`,config);
  
};
